module.exports = __webpack_public_path__ + "img/q2-second-son.b551adcd.svg";